import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { Helmet as ReactHelmet } from 'react-helmet';

import { EKOMI_CUSTOMER_ID, EKOMI_OPINIONS_TOKEN, EKOMI_STARS_TOKEN } from './EkomiPDPWidget.config';

import './EkomiPDPWidget.style.scss';

/** @namespace Pwa/Component/EkomiPDPWidget/Component */
export class EkomiPDPWidget extends PureComponent {
    static propTypes = {
        productId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        type: PropTypes.oneOf(['renderStars', 'renderOpinions']).isRequired,
    };

    static defaultProps = {
        productId: null,
    };

    componentWillUnmount() {
        this.removeScript();
    }

    appendScript() {
        const { type } = this.props;
        const token = type === 'renderStars' ? EKOMI_STARS_TOKEN : EKOMI_OPINIONS_TOKEN;

        return (
            <ReactHelmet>
                <script defer type="text/javascript" id={`ekomi-widget-${token}`}>
                    {`function registerWidget (w, token) {
                        w['_ekomiWidgetsServerUrl'] = 'https://widgets.ekomi.com';
                        w['_customerId'] = ${EKOMI_CUSTOMER_ID};
            
                        if (w['_language'] == undefined) {
                            w['_language'] = new Array();
                        }
                        w['_language'][token] = 'auto';
            
                        if(typeof(w['_ekomiWidgetTokens']) !== 'undefined'){
                            w['_ekomiWidgetTokens'][w['_ekomiWidgetTokens'].length] = token;
                        } else {
                            w['_ekomiWidgetTokens'] = new Array(token);
                        }
                        if(typeof(ekomiWidgetJs) == 'undefined') {
                            ekomiWidgetJs = true;
                            var scr = document.createElement('script');scr.src = 'https://sw-assets.ekomiapps.de/static_resources/widget.js';
                            var head = document.getElementsByTagName('head')[0];head.appendChild(scr);
            
                        } else {if (typeof ekomiWidgetMain != 'undefined') {ekomiWidgetMain('ajax', token);}}
                        return true;
                    }
                    (function (w) {
                        var token = '${token}';
                        var k = document.getElementsByClassName("ekomi-widget-" + token);
                        for(var x=0;x<k.length;x++){ registerWidget(w,token); }
                    })(window);`}
                </script>
            </ReactHelmet>
        );
    }

    removeScript() {
        const { type } = this.props;
        const token = type === 'renderStars' ? EKOMI_STARS_TOKEN : EKOMI_OPINIONS_TOKEN;

        const scriptTag = document.getElementById(`ekomi-widget-${token}`);

        if (scriptTag) {
            scriptTag.remove();
        }

        const scriptTags = document.getElementsByTagName('script');
        for (let i = 0; i < scriptTags.length; i++) {
            if (scriptTags[i].src.includes('ekomiapps.de')) {
                scriptTags[i].remove();
            }
        }
    }

    renderHtml() {
        const { productId, type } = this.props;
        const token = type === 'renderStars' ? EKOMI_STARS_TOKEN : EKOMI_OPINIONS_TOKEN;

        return (
            <>
                <div id="widget-container" className={`data-ekomi-emp ekomi-widget-container ekomi-widget-${token}`} />
                <div id="ekomi-product-widget-identifier" className="prod-data-emp" style={{ visibility: 'hidden' }}>
                    {productId}
                </div>
                <a href="https://www.ekomi-pl.com/opinie-pieknowdomu.pl.html" target="_blank" rel="noreferrer">
                    <img
                        alt="Pieknowdomu.pl Reviews with ekomi-pl.com"
                        src="https://smart-widget-assets.ekomiapps.de/resources/ekomi_logo.png"
                        style={{ display: 'none' }}
                    />
                </a>
            </>
        );
    }

    render() {
        const { productId } = this.props;

        if (productId) {
            return (
                <>
                    {this.renderHtml()}
                    {this.appendScript()}
                </>
            );
        }

        return null;
    }
}

export default EkomiPDPWidget;
